import React, { Component, PropTypes } from 'react';
import { Link, IndexLink } from 'react-router';

import GlobalNav from '../globalNav/globalNav';
import { genericRoute } from '../../routes';
import HeaderFilter from './headerFilter/headerFilter';
import ErrorToaster from './errorToaster/errorToaster';
import SearchPage from './searchPage/searchPage';

import Carousel from '../carousel/carousel';
import Image from '../image/image';

import css from './header.scss';

import gaPush from '../../utils/gaTrack';

//import fwaLogo from './fwa-logo.png';
//import BurgerIcon from './burger.png';
//import BurgerIconClose from './burger-close.png';
//import Burger from 'babel!svg-react!./burger.svg?name=Burger';

export default class Header extends Component {
	static propTypes = {
		menuActive: PropTypes.bool.isRequired,
		mainMenu: PropTypes.object.isRequired,
		subMenu: PropTypes.object.isRequired,
		menuActions: PropTypes.object.isRequired,
		categories: PropTypes.object.isRequired,
		errors: PropTypes.object.isRequired,
	};

	constructor(props) {
		super(props);

		this.state = {
			firstRender: true,
		};
	}

	componentDidUpdate() {
		if (this.state.firstRender) {
			this.t && clearTimeout(this.t);
			this.t = setTimeout(() => {
				this.setState({
					firstRender: false,
				});
			}, 50);
		}
	}

	render() {
		var menuButtonClass = 'header-main__logo-area__menu-button';
		if (this.isMenuActive()) {
			menuButtonClass += ' header-main__logo-area__menu-button--active';
		}

		if (this.state.firstRender) {
			menuButtonClass += ' header-main__logo-area__menu-button--before-entering';
		}

		let logoClassName = 'span2 span4-tablet span14-mobile header-main__logo-area';

		/* TabIndex: 0 = FOCUSABLE : -1 = NOT FOCUSABLE */

		return (
			<div
				className='header-container'
				tabIndex={(this.props.menuActive || this.props.searchActive) ? '0' : '-1'}
				onClick={(e) => {
					e.stopPropagation();
				}}

				onKeyUp={(e) => {
					if (e.keyCode === 27) { // ESC
						if (this.props.menuActive || this.props.searchActive) this.props.dispatch({ type: 'MENU_CLOSE' });
					}
				}}
			>
				<header className='full-span--wborder header-main'>
					<div className={logoClassName}>
						<Link to={genericRoute(false, '', false)} onClick={() => { this.isMenuActive() && this.props.menuActions.toggleMenu();}} className='header-main__logo-area__home-link'></Link>

						<button onClick={this.props.menuActions.toggleMenu} className={menuButtonClass}>
							<div className='burger-icon'>
								<span><i></i></span>
								<span><i></i></span>
								<span><i></i></span>
							</div>
							<div className='close-icon'>
								<span><i></i></span>
								<span><i></i></span>
							</div>
						</button>
					</div>

					<div className='span8 span6-tablet push14-mobile header-main__search-area'>

						<ErrorToaster {...this.props.errors} clearErrors={this.props.errorActions.clearErrors} />


						<Link to={genericRoute(false, 'search', false)} className={'header-main__search-area__search-icon' + (this.props.searchActive ? ' header-main__search-area__search-icon--active' : '')} onClick={(e) => {
							e.preventDefault();
							this.props.menuActions.toggleSearchMenu();
						}}></Link>
						{this.renderAdvertiseHere()}
					</div>

					{this.renderPromoArea()}

					{this.props.showTimelineFilter && (
						<HeaderFilter categories={this.props.categories} timelineActions={this.props.timelineActions} isFetching={this.props.timelines.isFetching} browser={this.props.browser} />
					)}
				</header>

				<GlobalNav {...this.props} />

				<SearchPage {...this.props} />
			</div>
		);
	}

	isMenuActive() {
		return this.props.menuActive;
	}

	renderAdvertiseHere() {
		if (this.isMenuActive()) {
			return (
				<Link to={genericRoute(false, 'advertise', false)} className='header-main__search-area__advert hide-mobile' onClick={() => {this.props.dispatch({ type: 'MENU_CLOSE' });}}>Advertise Here</Link>
			);
		}
	}

	renderPromoArea() {
		let startingSlide = Math.floor(Math.random() * this.props.ads.items.length);
		let className = 'span4 span4-mobile push5-mobile header-main__promo-area';

		if (this.props.menuActive || this.props.searchActive) {
			className += ' header-main__promo-area--active';
		}

		return (
			<div className={className}>
				<Carousel autoplay={true} timer={5000} decorators={false} startingSlide={startingSlide}>
					{this.props.ads.items.map((item, i) => {
						return (
							<a key={i} href={item.url} onClick={()=>gaPush('event', 'ads', item.url)} target='_blank'>
								<Image
									img={item.image}
									useExactBreakpoint={true}
									browser={this.props.browser}
									startingSlide={Math.floor(Math.random() * this.props.ads.items.length)}
									span='span4'
									className='span4'
								/>
						</a>
						);
					})}
				</Carousel>
			</div>
		);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/header/header.js
 **/